import isNil from 'lodash/isNil';

export const fireGtagEvent = (name, label, category, nonInteraction, value) => {
  if (typeof gtag === "undefined") {
    console.error(new Error('function gtag is not defined'));
    return;
  }

  let gtagDetails = {
    'event_label': label,
    'event_category': category,
    'non_interaction': nonInteraction
  }

  if (!isNil(value)) {
    gtagDetails = {
      ...gtagDetails,
      'event_value': value
    }
  }

  gtag('event', name, gtagDetails);
}

const formatIndexedLabel = (label, index) => `${label} - ${index}`;

export const getEventLabel = (label, index) => isNil(index) ? label : formatIndexedLabel(label, index);

